<template>
  <x-page title="订单详情" :loading="loading">
    <template v-if="!loading">
      <div ref="roll" :class="_['detail-roll']">
        <div :class="_['head']">
          <div :class="_['head-bg']">
            <div :class="_['order-state']">
              <div :class="_.statetxt">
                <img
                  :src="
                    orderInfo.status == 900
                      ? icon.doingIcon
                      : orderInfo.status == 901
                      ? icon.closeIcon
                      : icon.orderStateIcon
                  "
                  alt=""
                />
                <div :class="_['state-date']">
                  <p :class="_['state']">{{ orderInfo.statusName }}</p>
                  <p :class="_['date']" class="myorderdateclose">
                    <span
                      v-if="
                        orderInfo.status != 901 &&
                        orderInfo.status != 401 &&
                        orderInfo.status != 900
                      "
                    >
                      <van-count-down
                        :class="_.datestyle"
                        :time="
                          orderInfo.status == 400
                            ? orderInfo.countDownTime.cancelOrderCountDown
                            : orderInfo.status == 402
                            ? orderInfo.countDownTime.confirmCountDown
                            : orderInfo.countDownTime.closeCountDown
                        "
                        :format="`DD 天 HH 时 mm 分后${
                          orderInfo.status == 402 ? '订单自动完成' : '关闭订单'
                        }`"
                        @finish="getOrderDetail"
                      />
                    </span>
                    <span
                      v-if="orderInfo.status != 400 && orderInfo.status != 402"
                      >{{ orderInfo.statusReason }}</span
                    >
                  </p>
                </div>
              </div>
              <div :class="_.result">
                {{ orderInfo.saleAfterStatusLabel }}
              </div>
            </div>
          </div>
        </div>

        <div v-if="orderInfo.tips" :class="_.refundtip">
          {{ orderInfo.tips }}
        </div>

        <div :class="_['order-detail']">
          <div :class="_['consignee-info']">
            <div
              v-if="orderInfo.deliverUser.serviceUserName"
              :class="[_.courier, _._hairlineBottom]"
            >
              <div :class="_.info">
                <img :class="_.icon" :src="icon.courierIcon" alt="" />
                <div>
                  <span :class="_.title">配送人员</span>
                  <div :class="_.namephone">
                    <span :class="_.name">{{
                      orderInfo.deliverUser.serviceUserName
                    }}</span>
                    <span :class="_.phone">{{
                      orderInfo.deliverUser.serviceUserTel
                    }}</span>
                  </div>
                  <div :class="_.tip">
                    配送方：{{ orderInfo.deliverUser.tips }}
                  </div>
                </div>
              </div>
              <div
                v-track="{
                  name: '订单详情-联系配送人员',
                  id: 'cl9qfvi2h001ekcug1wbgephg',
                }"
                @click="
                  handleContactClick(orderInfo.deliverUser.serviceUserTel)
                "
              >
                <van-icon name="arrow" />
              </div>
            </div>
            <div :class="_.flexwidth">
              <div :class="_['address-icon']">
                <img :class="_['icon']" :src="icon.locationIcon" />
              </div>
              <div :class="_['consignee-info-detail']">
                <div :class="_['name-phone']">
                  <div>
                    <span :class="_.name">{{
                      orderInfo.consigneeInfo.name
                    }}</span>
                    <span :class="_.phone">{{
                      orderInfo.consigneeInfo.tel
                    }}</span>
                  </div>
                  <div
                    v-track="{
                      name: '订单详情-联系收货人',
                      id: 'cl9qfw49k001gkcug0twcb7zt',
                    }"
                    :class="_.txt"
                    @click="handleContactClick(orderInfo.consigneeInfo.tel)"
                  >
                    <!-- <a :href="'tel:' + orderInfo.consigneeInfo.tel"> -->
                    联系收货人
                    <!-- </a> -->
                  </div>
                </div>
                <div :class="_['address']">
                  {{ orderInfo.consigneeInfo.province
                  }}{{ orderInfo.consigneeInfo.city }}市{{
                    orderInfo.consigneeInfo.area
                  }}区{{ orderInfo.consigneeInfo.address }}
                </div>
              </div>
            </div>
          </div>
          <div :class="_['buyers-order']">
            <div :class="[_['buyers'], _._hairlineBottom]">
              <span>买家：{{ orderInfo.userName }}</span>
              <span :class="_.phone">({{ orderInfo.userPhone }})</span>
            </div>
            <div
              v-for="(item, index) in orderInfo.commodities"
              :key="index"
              :class="_['order-list']"
            >
              <div :class="_['list']">
                <img :class="_['order-img']" :src="item.pic" alt="" />
                <div :class="_['order-info']">
                  <div :class="_['order-name-space']">
                    <span :class="[_._ellipsis2, _['order-name']]">{{
                      item.name
                    }}</span>
                    <span :class="_.space">¥{{ item.totalPrice }}</span>
                  </div>
                  <div :class="_['order-num']">
                    <span>{{ item.skuDesc }}</span>
                    <span>x{{ item.quantity }}</span>
                  </div>
                </div>
              </div>
            </div>
          </div>

          <div :class="_['order-space-detail']">
            <div :class="_['space-item']">
              <span>打包费</span>
              <span>￥{{ orderInfo.packagePrice.toFixed(2) }}</span>
            </div>
            <div :class="[_['space-item'], _['margintop-12']]">
              <span>用户配送费</span>
              <span>￥{{ orderInfo.postFee.toFixed(2) }}</span>
            </div>
            <div
              v-for="(item, index) in orderInfo.discountItems"
              :key="index"
              :class="[_['space-item'], _['margintop-12']]"
            >
              <span>{{ item.name }}</span>
              <span>￥{{ item.amount.toFixed(2) }}</span>
            </div>
            <div :class="_['total-space']">
              <div></div>
              <div>
                <span>
                  已优惠
                  <span :class="_['space-red']"
                    >¥{{ orderInfo.discountAmount.toFixed(2) }}</span
                  >
                </span>
                <span :class="_['total']">
                  合计
                  <span :class="_['space-red']"
                    >¥{{ orderInfo.payAmount.toFixed(2) }}</span
                  >
                </span>
              </div>
            </div>
          </div>

          <div :class="_['pay-detail']">
            <div :class="_['pay-item']">
              <div :class="_['pay-item-name']">订单编号：</div>
              <div>
                <span>{{ orderInfo.orderNo }}</span>
                <span :class="_['copy']" @click="copyOrderNo(orderInfo.orderNo)"
                  >复制</span
                >
              </div>
            </div>
            <div :class="[_['pay-item'], _['margintop-12']]">
              <div :class="_['pay-item-name']">支付方式：</div>
              <div>
                <span>{{ orderInfo.payType }}</span>
              </div>
            </div>
            <div :class="[_['pay-item'], _['margintop-12']]">
              <div :class="_['pay-item-name']">支付编号：</div>
              <div>
                <span>{{ orderInfo.paySerialNo }}</span>
              </div>
            </div>
            <div :class="[_['pay-item'], _['margintop-12']]">
              <div :class="_['pay-item-name']">下单时间：</div>
              <div>
                <span>{{ orderInfo.orderTime }}</span>
              </div>
            </div>
            <div :class="[_['pay-item'], _['margintop-12']]">
              <div :class="_['pay-item-name']">付款时间：</div>
              <div>
                <span>{{ orderInfo.payTime }}</span>
              </div>
            </div>
            <div
              v-if="orderInfo.closeTime"
              :class="[_['pay-item'], _['margintop-12']]"
            >
              <div :class="_['pay-item-name']">关闭时间：</div>
              <div>
                <span>{{ orderInfo.closeTime }}</span>
              </div>
            </div>
            <div
              v-if="orderInfo.refundTime"
              :class="[_['pay-item'], _['margintop-12']]"
            >
              <div :class="_['pay-item-name']">退款时间：</div>
              <div>
                <span>{{ orderInfo.refundTime }}</span>
              </div>
            </div>
            <div :class="[_['pay-item'], _['margintb-12']]">
              <div :class="_['pay-item-name']">备注：</div>
              <div>
                <span>{{ orderInfo.remark }}</span>
              </div>
            </div>
            <div
              v-track="{
                name: '订单详情-联系买家',
                id: 'cl9qfxanb001ikcugbgchbxmi',
              }"
              :class="[_['contact-seller'], _._hairlineTop]"
              @click="handleContactClick(orderInfo.userPhone)"
            >
              <img :src="icon.phoneIcon" alt="" />
              <span>
                <!-- <a :href="'tel:' + orderInfo.userPhone">联系卖家</a> -->
                联系买家
              </span>
            </div>
          </div>
        </div>
      </div>
      <div
        v-if="orderInfo.status == 400 || orderInfo.status == 401"
        :class="_['bottom-btn']"
      >
        <div></div>
        <div v-if="orderInfo.status == 400" :class="_['btn-group']">
          <van-button
            v-track="{
              name: '订单详情-拒绝接单',
              id: 'cl9qfxurr001kkcug609e6xwi',
            }"
            :class="_['btn']"
            round
            type="default"
            @click="refuseShow = !refuseShow"
            >拒绝接单</van-button
          >
          <van-button
            v-track="{
              name: '订单详情-接单',
              id: 'cl9qfyg5j001mkcug29d75fvs',
            }"
            :class="[_['btn'], _.secBtn]"
            round
            type="default"
            @click="agreeTakeOrder(orderInfo.orderNo)"
            >接单</van-button
          >
        </div>
        <div v-if="orderInfo.status == 401" :class="_['btn-group']">
          <van-button
            v-track="{
              name: '订单详情-立即配送',
              id: 'cl9qfyxvs001okcug310r56om',
            }"
            :class="_['btn']"
            round
            type="default"
            @click="takeDelivery"
            >立即配送</van-button
          >
        </div>
      </div>
      <div
        v-if="orderInfo.saleAfterStatus == 1"
        :class="[_['bottom-btn'], _.txtstyle]"
      >
        请到电脑端后台处理售后订单
      </div>
      <refuseSheet
        :show="refuseShow"
        @close="close"
        @confirmReason="confirmReason"
      />
      <addDeliverySheet
        :order-no="orderInfo.orderNo"
        :show="showDelivery"
        @closeEmit="deliveryClose"
      />
    </template>
  </x-page>
</template>

<script>
  import addDeliverySheet from '../components/AddDeliveryPerson.vue'
  import icon from './orderIcon'
  import refuseSheet from '../components/refuseSheet.vue'
  import Vue from 'vue'

  import {
    apiOrderMerchantOrderDetail,
    apiOrderMerchantOrderReject,
    apiOrderMerchantOrderTake,
  } from '@/api'
  import { copyTextToClipboard } from 'vtils'
  import { dcb } from '@dcb/jssdk'
  import { Toast } from 'vant'
  import { Track } from '@/utils/Track'

  export default Vue.extend({
    components: { addDeliverySheet, refuseSheet },
    mixins: [
      Track.provideMark(() => ({
        page: '订单详情',
      })),
    ],
    data() {
      return {
        icon: icon,
        orderId: '',
        orderInfo: {},
        refuseShow: false,
        showDelivery: false,
      }
    },
    computed: {
      loading() {
        return false
      },
    },
    created() {
      if (this.$route.query.id) {
        this.orderId = this.$route.query.id
      }
    },
    mounted() {
      this.getOrderDetail()
    },
    methods: {
      //立即配送
      takeDelivery() {
        this.showDelivery = true
      },
      deliveryClose() {
        this.showDelivery = false
        Toast.success('配送成功')
        this.getOrderDetail()
      },
      close() {
        this.refuseShow = false
      },
      //同意接单
      async agreeTakeOrder(No) {
        await apiOrderMerchantOrderTake({ orderNo: No }, { hasStoreCode: true })
        Toast.success('接单成功')
        this.getOrderDetail()
      },
      //拒绝接单
      async rejectTakeOrder(No, reason) {
        const result = await apiOrderMerchantOrderReject(
          { orderNo: No, reason: reason },
          { hasStoreCode: true },
        )
        Toast.success('拒绝接单成功')
        this.getOrderDetail()

        console.log('reject---->', result)
      },
      //拒绝弹框回调
      confirmReason(reas) {
        this.rejectTakeOrder(this.orderInfo.orderNo, reas)
        this.refuseShow = false
      },
      async getOrderDetail() {
        const result = await apiOrderMerchantOrderDetail(
          { orderNo: this.orderId },
          { hasStoreCode: true },
        )
        this.orderInfo = result
        this.$nextTick(() => {
          if (result.status !== 400 && result.status !== 401) {
            if (result.saleAfterStatus === 1) return
            this.$refs.roll.style.height = '100%'
          }
        })
      },
      copyOrderNo(No) {
        copyTextToClipboard(No)
        Toast.success('复制订单成功')
      },
      //拨打电话
      // 点击联系客服
      handleContactClick(phoneNumber) {
        dcb.makePhoneCall({
          phoneNumber: phoneNumber,
        })
      },
    },
  })
</script>

<style lang="scss" module>
  .margintop-12 {
    margin-top: 12px;
  }

  .marginbottom-20 {
    margin-bottom: 20px;
  }

  .margintb-12 {
    margin-top: 12px;
    margin-bottom: 12px;
  }

  .detail-roll {
    height: calc(100% - 54px);
    overflow: scroll;
    .head {
      width: 100%;
      height: 86px;
      .head-bg {
        width: calc(100% - 24px);
        height: 63px;
        padding: 12px 12px 0 12px;
        background: linear-gradient(180deg, #ff273c 0%, #ff111c 100%);
        border-bottom-left-radius: 5%;
        border-bottom-right-radius: 5%;
        .order-state {
          width: calc(100% - 24px);
          height: 42px;
          background: #ffffff;
          border-radius: 8px;
          padding: 16px 12px;
          display: flex;
          align-items: center;
          justify-content: space-between;
          .statetxt {
            display: flex;
            align-items: center;
          }
          .result {
            font-size: 12px;
            font-weight: 400;
            color: #999999;
          }
          .state-date {
            margin-left: 8px;
            .state {
              font-size: 16px;
              font-weight: 500;
              color: #222222;
            }
            .date {
              font-size: 12px;
              font-weight: 400;
              color: #888888;
            }
          }
        }
      }
    }
    .refundtip {
      width: calc(100% - 16px);
      margin-top: 12px;
      background: #ffe9ea;
      padding: 8px 12px;
      font-size: 12px;
      font-weight: 400;
      color: #ff202a;
      line-height: 17px;
    }
    .order-detail {
      width: calc(100% - 24px);
      padding: 12px;
      .consignee-info {
        background: #ffffff;
        border-radius: 8px;
        padding: 0 15px 12px 15px;
        .courier {
          display: flex;
          justify-content: space-between;
          align-items: center;
          font-size: 14px;
          padding-top: 12px;
          padding-bottom: 12px;
          .info {
            display: flex;
            .icon {
              width: 18px;
              height: 18px;
              margin-right: 8px;
            }
            .title {
              font-weight: 500;
              color: #222222;
            }
            .namephone {
              margin-top: 5px;
              .name {
                color: #222222;
                margin-right: 8px;
              }
              .phone {
                color: #888888;
              }
            }
            .tip {
              margin-top: 5px;
              font-size: 12px;
              color: #888888;
            }
          }
        }
        .flexwidth {
          width: calc(100%);
          display: flex;
          padding-top: 12px;
        }
        .address-icon {
          display: flex;
          height: 13px;
          margin-top: 3px;
          margin-right: 12px;
        }
        .consignee-info-detail {
          width: 100%;
          .name-phone {
            display: flex;
            justify-content: space-between;
            font-size: 14px;
            font-weight: 400;
            .name {
              color: #222222;
            }
            .phone {
              margin-left: 8px;
              color: #888888;
            }
            .txt {
              color: #2e7dff;
            }
          }
          .address {
            margin-top: 5px;
            font-size: 12px;
            font-weight: 400;
            color: #222222;
          }
        }
      }
      .buyers-order {
        width: calc(100% - 24px);
        margin-top: 12px;
        background: #ffffff;
        border-radius: 8px;
        padding: 12px;
        .buyers {
          font-size: 14px;
          font-weight: 500;
          color: #222222;
          padding-bottom: 12px;
          .phone {
            color: #888888;
            margin-left: 6px;
          }
        }
        .order-list {
          width: 100%;
          padding-top: 11px;
          .list {
            display: flex;
            .order-img {
              width: 61px;
              height: 61px;
              background: #d8d8d8;
              border-radius: 8px;
            }
            .order-info {
              width: 100%;
              margin-left: 12px;
              display: flex;
              flex-direction: column;
              justify-content: space-between;
              .order-name-space {
                display: flex;
                justify-content: space-between;
                font-size: 14px;
                font-weight: 400;
                color: #333333;
                .order-name {
                  width: calc(100% - 76px);
                  height: 40px;
                }
                .space {
                  font-size: 14px;
                  font-weight: 500;
                  color: #333333;
                }
              }
              .order-num {
                display: flex;
                justify-content: space-between;
                font-size: 12px;
                font-weight: 400;
                color: #999999;
              }
            }
          }
        }
      }
      .order-space-detail {
        width: calc(100% - 24px);
        margin-top: 12px;
        padding: 12px;
        background: #ffffff;
        border-radius: 8px;
        .space-item {
          display: flex;
          justify-content: space-between;
          font-size: 14px;
          font-weight: 400;
          color: #333333;
        }
        .total-space {
          display: flex;
          justify-content: space-between;
          font-size: 14px;
          font-weight: 400;
          color: #333333;
          .total {
            margin-left: 10px;
          }
          .space-red {
            color: #ff202a;
          }
        }
      }
      .pay-detail {
        width: calc(100% - 24px);
        margin-top: 12px;
        padding: 12px;
        background: #ffffff;
        border-radius: 8px;
        .pay-item {
          display: flex;
          font-size: 12px;
          font-weight: 400;
          color: #222222;
          .pay-item-name {
            width: 72px;
            // margin-right: 12px;
          }
          .copy {
            width: 32px;
            height: 16px;
            margin-left: 8px;
            background: #fff3f2;
            border-radius: 8px;
            font-size: 11px;
            font-weight: 400;
            padding: 3px 6px;
            color: #ff202a;
          }
        }
        .contact-seller {
          width: 100%;
          height: 44px;
          background: #ffffff;
          border-radius: 8px;
          font-size: 14px;
          font-weight: 500;
          color: #1d1d1c;
          display: flex;
          justify-content: center;
          align-items: center;
        }
      }
    }
  }
  .txtstyle {
    justify-content: center !important;
    font-size: 14px;
    font-weight: 400;
    color: #2e7dff;
    line-height: 54px;
    text-align: center;
  }
  .bottom-btn {
    position: fixed;
    bottom: 0;
    width: 100%;
    height: 54px;
    background: #ffffff;
    display: flex;
    justify-content: space-between;
    align-items: center;
    box-shadow: 0px -1px 2px 0px rgba(239, 239, 239, 0.5);

    .btn-group {
      // width: 184px;
      height: 30px;
      display: flex;
      justify-content: space-between;
      margin-right: 12px;

      .btn {
        width: 86px;
        height: 30px;
        line-height: 30px;
        border-radius: 17px;
        opacity: 0.93;
        border: 1px solid #bebebe;
        font-size: 13px;
        font-weight: 400;
        color: #222222;
      }
      .secBtn {
        margin-left: 12px;
      }
    }
  }
</style>
<style lang="scss">
  .orderDetail_date_2lATj,
  .myorderdateclose {
    .van-count-down {
      font-size: 12px;
      font-weight: 400;
      color: #888888;
    }
  }
</style>
